import React, { useEffect, useState } from 'react';
import { generatePrintableQRCode } from '../utils/qrcode';
import { SeatConfig } from '../types';

interface SeatQRCodeProps {
  seatNumber: number;
  config: SeatConfig;
}

const SeatQRCode: React.FC<SeatQRCodeProps> = ({ seatNumber, config }) => {
  const [qrCodeUrl, setQRCodeUrl] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const loadQRCode = async () => {
      try {
        setIsLoading(true);
        const url = await generatePrintableQRCode(seatNumber);
        setQRCodeUrl(url);
      } catch (error) {
        console.error('QRコードの生成に失敗しました:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadQRCode();
  }, [seatNumber]);

  return (
    <div className="seat-qrcode">
      {isLoading ? (
        <div className="loading">QRコード生成中...</div>
      ) : (
        <>
          <div className="seat-number">席番号 {seatNumber}</div>
          <div className="qrcode-container">
            <img src={qrCodeUrl} alt={`席番号 ${seatNumber} のQRコード`} />
          </div>
          <div className="qrcode-instruction">
            席を確認するにはQRコードをスキャンしてください
          </div>
        </>
      )}
    </div>
  );
};

export default SeatQRCode; 